import { render, staticRenderFns } from "./ReferralsNewBack.vue?vue&type=template&id=2d621646"
import script from "./ReferralsNewBack.vue?vue&type=script&lang=js"
export * from "./ReferralsNewBack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports